import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import { logoutApi } from '../../api/authService';
import { clearFiles } from '../../utils/db';

export const logoutThunk = createAsyncThunk(
  'logout/logoutThunk',
  async (_, { rejectWithValue }) => {
    try {
      const res = await logoutApi();
      return res;
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      return rejectWithValue(message || 'Не удалось выполнить выход. Попробуйте позже.');
    } finally {
      // httpOnly-куку (обычная сессия по SMS) фронт не может прочитать
      // или удалить - сервер должен сам стереть её в ответе на
      // logoutApi() (через Set-Cookie с Max-Age=0), если он этого не
      // делает, нужно уточнить у бэкенда отдельно.
      //
      // init_auth_token на домене ФРОНТЕНДА - другая история: её пишет
      // InitPage.jsx для служебной ссылки входа, и её фронт стереть
      // МОЖЕТ (не httpOnly). Если не стирать - после нажатия "Выйти"
      // это устаревшее значение осталось бы лежать в браузере, и
      // перехватчик в api.js снова подставил бы его в Authorization при
      // следующем запросе - человек нажал "Выйти", а фактически остался
      // бы залогинен через служебную сессию.
      Cookies.remove('init_auth_token');
      try {
        await clearFiles();
      } catch {
        // сбой очистки IndexedDB не должен ломать сам логаут
      }
    }

    // редирект делается в компоненте после успешного logoutThunk
  }
);

const logoutSlice = createSlice({
  name: 'logout',
  initialState: { status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logoutThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(logoutThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(logoutThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error?.message || 'Ошибка выхода';
      });
  },
});

export default logoutSlice.reducer;
